import { useParams, useNavigate } from 'react-router-dom'
import { useQuery, useMutation } from '@apollo/client/react'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Table from '@components/pages/Merchant/DetailsTable'
import Toolbar from '@components/pages/Merchant/DetailsToolbar'
import toast from '@utils/toast'
import DELETE_MERCHANT from '@graphql/mutations/delete-merchant'
import GET_MERCHANT from '@graphql/queries/get-merchant'
import GET_MERCHANTS from '@graphql/queries/get-merchants'
import { t } from '@utils/translations'

function Details() {
  const { merchantId } = useParams()
  const navigate = useNavigate()
  const { data, loading, error } = useQuery(GET_MERCHANT, { variables: { id: merchantId } })

  const [deleteMerchant] = useMutation(DELETE_MERCHANT, {
    onCompleted() {
      navigate('/merchants/')
      toast(t('messages.merchantDeleted'))
    },
    onError(error) {
      const message = t('messages.merchantDeletionError', { error: error.message })
      toast(message, 'danger')
    },
    refetchQueries: [
      { query: GET_MERCHANTS, variables: { filters: {} } },
      'GetMerchants'
    ],
    update(cache, { data: { deleteMerchant } }) {
      const identity = cache.identify(deleteMerchant)
      cache.evict({ id: identity })
    }
  })

  return (
    <>
      <PageHeading
        heading='Merchant Details'
        toolbar={<Toolbar data={data} deleteMerchant={deleteMerchant} />}
      />

      {error ? (
        <Error error={error} />
      ) : (
        <Table merchant={data?.merchant} loading={loading} />
      )}
    </>
  )
}

export default Details
